import React from "react";
import { Link } from "react-router-dom";
import { Col, Row, Nav, NavItem, NavLink, Button } from "reactstrap";
import classnames from "classnames";

const BreadCrumb = ({
  title,
  pageTitle,
  exportToExcel,
  exportToPDF,
  customerName = "",
  modelName = "",
  activeTab, // New prop for active tab
  setActiveTab, // New prop to set active tab
}) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">{title}</h4>
            {/* <h4 className="mb-sm-0">{customerName || modelName}</h4> */}
            {customerName && <h4 className="mb-sm-0">{customerName}</h4>}
            {modelName && <h4 className="mb-sm-0">{modelName}</h4>}

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                {/* Tab Bar */}
                {title === "With HUID Stocks" && (
                  <Nav tabs className="nav-tabs mb-2">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "available",
                        })}
                        onClick={() => setActiveTab("available")}
                      >
                        Available Stocks
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "ordered",
                        })}
                        onClick={() => setActiveTab("ordered")}
                      >
                        Ordered Stocks
                      </NavLink>
                    </NavItem>
                  </Nav>
                )}{" "}
                {/* <li className="breadcrumb-item">
                  <Button
                    color="primary"
                    onClick={exportToExcel}
                    //className="me-1"
                    style={{ height: "30px" }}
                  >
                    Excel
                  </Button>
                </li> */}
                {/* <li className="breadcrumb-item">
                  <Button
                    color="primary"
                    onClick={exportToPDF}
                    //className="me-1"
                    style={{ height: "30px" }}
                  >
                    PDF
                  </Button>
                </li> */}
                {/* <li className="breadcrumb-item">
                  <Link to="#">{pageTitle}</Link>
                </li> */}
                {/* <li className="breadcrumb-item active">{title}</li> */}
              </ol>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BreadCrumb;
